import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
} from 'components/ui/drawer';

import { Button } from 'components/ui/button';
import { useDisclosure } from 'hooks/use-disclosure';

export type DocumentationDrawerProps = {
    buttonText: string;
    buttonClassName?: string;
    title: string;
    content: string | React.ReactNode;
};

export const DocumentationDrawer = ({
    buttonText,
    buttonClassName,
    title,
    content,
}: DocumentationDrawerProps) => {
    const { isOpen, toggle } = useDisclosure();

    return (
        <Drawer open={isOpen} onOpenChange={toggle}>
            <DrawerTrigger asChild>
                <Button className={buttonClassName} variant="link">
                    {buttonText}
                </Button>
            </DrawerTrigger>
            <DrawerContent className="flex max-w-[800px] flex-col justify-between overflow-scroll sm:max-w-[540px]">
                <div className="flex flex-col">
                    <DrawerHeader>
                        <DrawerTitle>{title}</DrawerTitle>
                    </DrawerHeader>
                    <div className="mt-6">{content}</div>
                </div>
                <DrawerFooter>
                    <DrawerClose asChild>
                        <Button>Close</Button>
                    </DrawerClose>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
};
